import React, { useEffect, useState } from 'react';
import { Card } from "antd";
import { MDBAlert, MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import { Button, SearchInput, TrashIcon } from "evergreen-ui";
import { Table } from 'antd';
import Firebase from "../Firebase/Firebase";
import FireFetch from "../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals } from "../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import { getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { useAuth } from "../AuthContext/AuthContext";

const columns = [

	{
		title: 'Record',
		dataIndex: 'record',
		key: 'record',
		sorter: (a, b) => a.record && a.record.localeCompare(b.record)
	},
	{
		title: 'RecordID',
		dataIndex: 'recordID',
		key: 'recordID',
		sorter: (a, b) => a.recordID && a.recordID.localeCompare(b.recordID)
	},
	{
		title: 'Action Type',
		dataIndex: 'type',
		key: 'type',
		sorter: (a, b) => a.type && a.type.localeCompare(b.type)
	},
	{
		title: 'Done By',
		key: 'user',
		dataIndex: 'user',
		responsive: ["sm"],
		sorter: (a, b) => a.user && a.user.localeCompare(b.user)

	},
	{
		title: 'Date',
		dataIndex: 'date',
		key: 'date',
		responsive: ["sm"],
		sorter: (a, b) => moment(a.date, "DD/MMM/YYYY HH:MM").diff(moment(b.date, "DD/MMM/YYYY HH:MM"))
	},
	{
		title: 'Action',
		key: 'action',
		dataIndex: 'action',

	},
];

var db = getDatabase(Firebase);
const auth = getAuth(Firebase);
const moment = require("moment");
const Logs = (props) => {
	const { canAccessModule } = useAuth();
	const canDeleteLog = canAccessModule("LOGS", "delete");

	const [checkedData, setCheckedData] = useState(false);
	const [dataArray, setDataArray] = useState([]);
	const [eventsData, setEventsData] = useState([]);
	const [logs, loading] = useListVals(ref(db, "talmidsdb/logs"))
	const [userArray] = useListVals(ref(db, "talmidsdb/users"))
	const [searchValue, setSearchValue] = useState();
	const [color, setColor] = useState("info");
	const [message, setMessage] = useState("");
	const [showAlert, setShowAlert] = useState(false);
	const [user, error] = useAuthState(auth)

	const callback = (data) => {
		setCheckedData(data);
	}

	const deleteLog = (id) => {
		if (!canDeleteLog) {
			alert("You do not have permission to delete logs.");
			return;
		}

		if (confirm("Are you sure you want to delete Log?")) {
			FireFetch.DeleteFromDB("Logs", id).then((message) => {
				if (message === "success") {

				} else {
					alert("Unable to delete");
				}
			}).catch((error) => {
				alert("Unable to delete");
			});
		}
	};

	useEffect(() => {
		if (user && logs) {
			if (userArray.find(x => x.id === user.uid) &&
				userArray.find(x => x.id === user.uid).userRole !== "SuperUser") {
				//not a superuser
				setMessage("Only a Superuser can view this page!")
				setColor("danger");
				setShowAlert(true);
			} else {
				var tempArray = [];
				logs.map((item, index) => {

					tempArray.push({
						key: index + 1,
						record: item.record,
						recordID: item.recordID,
						type: item.actionType,
						user: userArray[userArray.findIndex(x => (item.id) === x.id)] &&
							userArray[userArray.findIndex(x => (item.id) === x.id)].firstname + " "
							+ userArray[userArray.findIndex(x => (item.id) === x.id)].surname,
						date: moment(item.timeStamp, "YYYY-MM-DDTh:mm:ss").format("DD/MMM/YYYY HH:MM"),
						action: <div>
							{canDeleteLog && (
								<Button intent="danger" onClick={() => deleteLog(item.logID)}>
									<TrashIcon color="danger" />
								</Button>
							)}
						</div>
					});
				});
				setEventsData([...tempArray]);
				setDataArray([...tempArray]);
			}
		}
		if (error) {
			window.location.href = "/login";
		}
	}, [logs, userArray, user, canDeleteLog])

	const handleSearch = (searchText) => {
		const filteredEvents = dataArray.filter(({ record, type, user }) => {
			record = record && record.toLowerCase();
			type = type && type.toLowerCase();
			user = user && user.toLowerCase();
			return (record && record.includes(searchText)) || (type && type.includes(searchText)) || (user && user.includes(searchText));
		});
		setEventsData(filteredEvents);
	};

	return (
		<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
			<MDBRow className="w-100">
				<MDBCol md={12}>
					<Card className="w-100">
						<MDBRow>
							<MDBCol md={12}>
								<div className="text-left">
									<div className="d-flex flex-row justify-content-between">
										<div className="d-inline">
											<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
												<Text family='Nunito'>
													Logs
												</Text>
											</h5>
										</div>
										<div className="d-flex flex-row">
											<SearchInput placeholder="Filter through logs" onChange={e => handleSearch(e.target.value)} value={searchValue} />
											<Button appearance="primary" className="mx-1" onClick={() => {
												FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
													filename: "Logs",
													exportButtons: false,
													sheetname: "Logs",
												}));
											}}>
												Print
											</Button>
										</div>
									</div>
								</div>
							</MDBCol>
						</MDBRow>
					</Card>
					{showAlert ?
						<>
							<MDBAlert color={color} className="my-3 " >
								{message}
							</MDBAlert>
						</>
						: null}
					<Card>
						<Table id="dataTable" style={{ overflow: "auto" }}
							pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
							loading={loading} columns={columns} dataSource={eventsData}
							className="custom-table"
						/>
					</Card>
				</MDBCol>
			</MDBRow>
		</div>
	);
}

export default Logs;
